export enum MachinesRoutes {
  GetByMachineID = 'get-by-machineID',
  GetHwConfigs = 'get-hardware-configs',
  GetMachineModel = 'get-machine-model',
  GetMachineModels = 'get-machine-models',
  GetTeamMachines = 'get-team-machines',
  RestartMachine = 'restart-machine',
  UpdateMachine = 'update-machine',
}
